<template>
  <div class="productList">
    <breadcrumb
      v-bind:path1="path1"
      v-bind:path2="path2 || currentDisplayGroup.Name"
    ></breadcrumb>    <!--子导航-->
    <!-- <div class="page-width">
      <div class="sonNav" v-if="sonNavList.length">
        <swiper :options="recommendedSwiper" ref="mySwiper">
          <swiper-slide v-for="(item, index) in sonNavList" v-bind:key="index" class="categoryBtn">
            <a style="max-width: 136px" @click="fetchSelectedCategories(item)">{{item.Name}}</a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev el-icon-caret-left"></div>
        <div class="swiper-button-next el-icon-caret-right"></div> -->
        <!-- <ul class="hidden-md-and-down">
          <li v-for="(item, index) in sonNavList" @click="fetchSelectedCategories(item.ProductCategory_id)" v-bind:key="index">
            <a v-if='$i18n.locale=="en"'>{{item.Name}}</a>
            <a v-if='$i18n.locale=="ch"'>{{item.Description}}</a>
          </li>
        </ul> -->
      <!-- </div>
    </div> -->
    <!--end子导航-->

    <!--select order-->
    <div class="page-width display" v-if="currentDisplayGroup.Name">
      <!--product image-->
      <div class="collections-singleli" v-if="currentDisplayGroup.GroupImage&&currentDisplayGroup.GroupImage.length !== 0">
        <div class="ps_right">
          <div class="thumbnails-wrapper">
            <ul>
              <li v-for="(item,index) in currentDisplayGroup.GroupImage" :class="isactive == index?'isactive':''" :key="index">
                <a href="javascript:void(0)" @click="tabImg(index)"><img :src="item" alt=""></a>
                <!-- <a href="javascript:void(0)" @click="tabImg(0)"><img src="../assets/img/coming.png" alt=""></a> -->
              </li>
            </ul>
          </div>
        </div>
        <div class="ps_left">
          <div class="product-single__photo-wrapper sp-wrap" @click="clickZoom(currentDisplayGroup.GroupImage)">
            <!-- with zoom in -->
            <div v-show="zoom.screenWidth>773 && currentDisplayGroup.GroupImage.length !== 0">
              <vue-h-zoom
                :image="bigImg || currentDisplayGroup.GroupImage[0]"
                :image-full="zoomImg || currentDisplayGroup.GroupImage[0]"
                :zoom-level="4"
                :width="zoom.width"
                :height="zoom.height"
                :zoom-window-size="1"
                :zoom-window-x="zoom.zoomX"
                :zoom-window-y="zoom.zoomY"
                background-options="true"
              />
            </div>
            <!-- <img v-if="currentDisplayGroup.GroupImage.length === 0" src="../assets/img/coming.png" alt="" class="comingImg"/> -->
            <!-- no zoom in -->
            <div v-show="zoom.screenWidth<772">
              <img class="mobile-image" :src="bigImg || currentDisplayGroup.GroupImage[0]" alt="">
            </div>
          </div>
        </div>
      </div>
      <img v-if="currentDisplayGroup.GroupImage.length === 0" :src="groupImg" alt="" class="comingImg"/>
      <!--end product image-->
      <!--product detail-->
      <div class="collections-single__meta">
        <h1 class="product-single__title">{{currentDisplayGroup.Name}}</h1>
        <h1 class="product-single__desc">{{currentDisplayGroup.Description}}</h1>
      </div>
      <!--end product detail-->
    </div>
    <div class="collection-header">
      <div class="filters-toolbar-wrapper">
        <div class="page-width">
          <div class="filters-toolbar__item-child">
            <div class="filter" v-if="this.group.toLowerCase() !== 'smarts' && this.group.toLowerCase() !== 'wants'">
              <p>{{ $t('category') }} :</p>
              <el-select v-model="sonNavObj" value-key='Name' v-bind:placeholder="$t('pleaseSelectCategory')" @change="fetchSelectedCategories">
                <el-option
                  v-for="item in sonNavList"
                  :key="item.value"
                  :label="item.Name"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="filter">
              <p>{{ $t('sortBy') }} :</p>
              <el-select v-model="option" v-bind:placeholder="$t('pleaseSelectSortingMethod')" value="" @change="updateFilter">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end select order-->

    <!--列表主题-->
    <div v-if="this.isLoading" class="product-listing-container">
      <div class="page-width">
        <div class="loadmore disableBtn">
          <span>{{ $t('loadingProducts')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="!this.isLoading" class="product-listing-container">
      <div class="page-width">
        <ul v-if="this.list.length">
          <li v-for="(item, index) in list" v-bind:key="index" v-if="!item.IsStopSale">
            <productCard v-if='$i18n.locale=="en"'
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Name"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              :disable-link="true"
            ></productCard>
            <productCard v-if='$i18n.locale=="ch"'
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Description"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              :disable-link="true"
            ></productCard>
          </li>
        </ul>
        <div v-else class="loadmore disableBtn">
          <span>{{ $t('noMoreProducts')}}</span>
        </div>
        <div class="images-modal-mask" v-if="imagesVisible" @click.self="closeImages">
          <div class="images">
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="(item,index) in images" :key="'images'+index">
                <img :src="item" alt="" @click.self="closeImages">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import productCard from "./productCard";
import VueHZoom from 'vue-h-zoom';
Vue.use(VueHZoom);
// Vue.component('originalVueZoom', VueHZoom);
// const newZoom = Vue.component('originalVueZoom').extend({
//   methods: {
//     updateThumbnailPos: function () {
//       const el = this.$refs.thumbnail;
//       let elementDim = el.getBoundingClientRect();
//       this.thumbnailPos = {
//         top: elementDim.top,
//         left: elementDim.left,
//       }
//     }
//   }
// });
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart,
  flyToElement,
} from "../store/modules/cart";

export default {
  name: "productList",
  components: {
    breadcrumb,
    productCard,
    VueHZoom: VueHZoom
  },
  metaInfo() {
    return {
      title: this.currentDisplayGroup.metaTitle,
      meta: [{
        name: 'description',
        content: this.currentDisplayGroup.metaDescription,
      }]
    }
  },
  props: {
    group: {
      type: String,
    },
  },
  data() {
    return {
      isactive: 0,
      bigImg: "",
      zoomImg: "",
      zoom: {
        screenWidth: 0,
        width: 200,
        height: 200,
        zoomX: 400,
        zoomY: 100,
      },
      imagesVisible: false,
      images: [],
      b2bName: '',
      b2bDescription: '',
      isLoading: false,
      path1: {
        name: '',
        path: '/',
      },
      path2: '',
      chgroup: '',
      sonNavObj: {},
      sonNavList: [],
      // drop down filter
      option:"",
      options: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      }],
      recommendedSwiper: {
        slidesPerView: 5, // how many to shoe in a row
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          768: { slidesPerView: 4 },
          990: { slidesPerView: 4 },
          1200: { slidesPerView: 4 },
          1280: { slidesPerView: 5 }
        }
      },
      list: [],
      listReg: [],
      listOut: [],
      catReg: [],
      catOut: [],
      inCart: null,
      currentGroup: [],
      groupId: null,
      currentDisplayGroup: {},
      groupImg: require('../assets/img/coming.png')
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    tabImg(num) {
      this.bigImg = this.currentDisplayGroup.GroupImage[num]; // right side big img
      this.zoomImg = this.currentDisplayGroup.GroupImage[num]; // zoom big img
      this.isactive = num; // tab the img
    },
    //点击商品图片
    clickZoom(images){
      if(images.length !== 0){
        //显示商品图片的弹窗
        this.imagesVisible=true;
        this.images=images;
        let array1=[];
        let array2=[];
        images.forEach((item,index)=>{
          //保证当前点击的图片在第一位
          if(index === this.isactive){
            array1.unshift(item);
          }else{
            //保证此图片之前的在数组的最后
            if(index<this.isactive){
              // array1.splice(index,1)
              array2.push(item);
            }else{
              array1.push(item);
            }
          }
        })
        if(array2.length>0){
          this.images=[...array1,...array2]
        }else{
          this.images=[...array1]
        }
      }
    },
    closeImages(){
      this.imagesVisible=false;
    },
    initializeValue() {
      this.bigImg = "";
      this.zoomImg = "";
      this.isactive = 0;
      this.num = 1;
    },
    // this is not doing anything
    handleResize() {
      this.zoom.screenWidth = window.innerWidth;
      if (this.zoom.screenWidth>1139) {
        this.zoom.width = 400;
        this.zoom.height = 400;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth<1140 && this.zoom.screenWidth>892) {
        this.zoom.width = 300;
        this.zoom.height = 300;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth<893 && this.zoom.screenWidth>772) {
        this.zoom.width = 278;
        this.zoom.height = 278;
        this.zoom.zoomX = 300;
        this.zoom.zoomY = 100;
      }
    },
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true;
    },
    // Check if b2b items are out of stock so we sort them to the bottom.
    isOutOfStockBusiness(item) {
      let stock = item.StockLevel;
      let masterSoldout = true;
      let innerSoldout = true;

      // map through b2b items and check for proper casing. Add to hash map.
      // if (item.MasterInner.length) {
      //   item.MasterInner.map(b2bCase => {
      //     let itemStock = stock/b2bCase.ConvertNum;
      //     if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "0") {
      //       if (itemStock>=1) {
      //         masterSoldout = false;
      //       }
      //     }
      //     if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "2") {
      //       if (itemStock>=1) {
      //         innerSoldout = false;
      //       }
      //     }
      //   });
      // }
      // if (masterSoldout && innerSoldout) {
      //   return true;
      // } else {
      //   return false;
      // }
      if (item) {
        let itemStock = item.stock/item.ConvertNum;
        if (item.ProductNum.charAt(item.ProductNum.length - 1) === "0") {
          if (itemStock>=1) {
            masterSoldout = false;
          }
        }
        if (item.ProductNum.charAt(item.ProductNum.length - 1) === "2") {
          if (itemStock>=1) {
            innerSoldout = false;
          }
        }
      }
      if (masterSoldout && innerSoldout) {
        return true;
      } else {
        return false;
      }
    },
    sortSonNavList(list) {
      list = list.sort((a,b) => {
        return a.Name[0] > b.Name[0] ? 1 : -1;
      })
    },
    updateFilter(value) {
      if(value === '1') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if(value === '2') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if(value === '3') {
        this.list = this.list.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
    },
    fetchSelectedCategories(item) {
      this.isLoading = true;
      this.list = [];
      this.fetchCategories([item.ProductCategory_id, this.business])
      .then(res => {
        this.isLoading = false;
        let ctemp1 = [];
        let ctemp2 = [];
        let sortedDataStock = res.data.map((a) => {
          if (this.isOutOfStock(a)) {
            ctemp2.push(a)
          } else {
            ctemp1.push(a)
          }
        })
        this.catOut = ctemp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.catReg = ctemp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.currentDisplayGroup['category'] = item.Name;
        // this.currentDisplayGroup['description'] = item.CategoryDescription;
        this.currentDisplayGroup['metaTitle'] = item.MetaTitle;
        this.currentDisplayGroup['metaDescription'] = item.MetaDescription;
        this.list = this.catReg.concat(this.catOut);
      })
      .catch(err => {
        console.log('err fetching product', err);
      })
    },
    fetchSelectedGroup(id) {
      let data = {
        id: id,
        isB2B: this.business
      }
      this.isLoading = true;
      this.sonNavObj = {};
      this.fetchProductsWithGroupId(data)
      .then(res => {
        this.isLoading = false;
        const temp1 = [];
        const temp2 = [];
        const sortedData = res.data.map((a)=>{
          if (this.business) {
            if (this.isOutOfStockBusiness(a)) {
              temp2.push(a)
            } else {
              temp1.push(a)
            }
          } else {
            if (this.isOutOfStock(a)) {
              temp2.push(a)
            } else {
              temp1.push(a)
            }
          }
        });
        this.listOut = temp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.listReg = temp1.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.list = this.listReg.concat(this.listOut);
      })
      .catch(err => {
        this.isLoading = false;
        console.log('err', err)
      })
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
        flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        flyToElement(event.target, $('.cart-link'));
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      // this.$router.push({ name: 'productDetails', params: { productNum: product.ProductNum} })
      this.$router.push({ path: '/productDetails', query: { productNum: product.ProductNum}})
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    allGroups: state => state.navbar.allGroups,
    activeCategory: state => state.products.activeCategory,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    itemCount: state => state.cart.itemCount,
    business: state => state.auth.userDetails.IsBusiness,
    userDetails: state => state.auth.userDetails,
    determineCase(item) {
      let properCase;
      if (item.MasterInner.length === 1) {
        item.MasterInner.map(container => {
          if (container.ProductNum.charAt(num.length - 1) === '0') {
            properCase = "master"
          }
          if (container.ProductNum.charAt(num.length - 1) === '2') {
            properCase = "inner"
          }
        });
      }
      if (item.MasterInner.length === 2) {
        properCase = "master";
      }
      return properCase;
    },
  }),
  watch: {
    '$route.query': {
      immediate: true,
      handler(groupVal) {
        const currentGroup = this.allGroups.filter(group => {
          return group.Name.toLowerCase() === this.group.toLowerCase();
        });
        this.currentDisplayGroup = currentGroup[0];
      }
    },
    allGroups: function(newVal, oldVal) {
      const currentGroup = newVal.filter(group => {
        return group.Name.toLowerCase() === this.group.toLowerCase();
      });
      this.currentDisplayGroup = currentGroup[0];
      this.initializeValue();
      this.sonNavList = currentGroup[0].Categories;
      this.sortSonNavList(this.sonNavList);
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
    },
    group: function(newVal, oldVal) {
      //每次点击此组别都会修改此组别的默认图
      if(localStorage.getItem('groupImg')){
        this.groupImg=localStorage.getItem('groupImg')
      }
      const currentGroup = this.allGroups.filter(group => {
        return newVal === group.Name.toLowerCase();
      });
      if (currentGroup) {
        this.chgroup = currentGroup[0].Description;
        const name = currentGroup[0].Name;
        const path = name.toLowerCase();
        this.path1.name = name;
        this.path1.path = `/collections/${path}`;
      };
      this.option = '';
      this.sonNavObj = {};
      this.sonNavList = currentGroup[0].Categories;
      this.sortSonNavList(this.sonNavList);
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
    },
    'userDetails.IsBusiness': {
      handler: function(newVal, oldVal) {
        const currentGroup = this.allGroups.filter(group => {
          return this.group === group.Name.toLowerCase();
        });
        if (currentGroup[0]) {this.chgroup = currentGroup[0].Description;}
        if(this.group.toLowerCase() !== 'smarts' && this.group.toLowerCase() !== 'wants' && currentGroup[0]) {
          this.sonNavList = currentGroup[0].Categories;
        }
        this.sortSonNavList(this.sonNavList);
        if (currentGroup[0]) {
          this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
        }
        deep: true
      }
    }
  },
  mounted: function() {
    console.log('mounted')
    //默认获取一次组别默认图
    if(localStorage.getItem('groupImg')){
      this.groupImg=localStorage.getItem('groupImg')
    }
    // check it is all empty
    this.$root.fetchSelectedGroup = this.fetchSelectedGroup.bind(this);
    const currentGroup = this.allGroups.filter(group => {
      return this.group === group.Name.toLowerCase();
    });
    if (currentGroup[0]) {
      this.chgroup = currentGroup[0].Description;
      this.sonNavList = currentGroup[0].Categories;
      this.sortSonNavList(this.sonNavList);
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
    }
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    }
  }
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
@import "../assets/css/jqzoom.css";
</style>



// WEBPACK FOOTER //
// src/view/productList.vue